// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #fccc34;
  --darker-primary: var(--darker-primary);
  --green: #47d444;
  --dark-green: #305f2f;
  --red: #cc3939;
  --black-100: #191919;
  --card-header: #2e2d2d;
  --black-200: #242424;
  --black-300: #292828;
  --black-400: #2e2d2d;
  --white: #ebebeb;
  --grey-100: #b8b8b8;
  --grey-200: #525252;
  --grey-300: #3d3d3d;
  --orange: #FF7900;
  --white-5: #FDFDFD;
  --white-100: #FFF;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: var(--black-100);
}

@media (max-width: 1080px) {
  html {
    font-size: 93.75%;
  }
}
@media (max-width: 720px) {
  html {
    font-size: 87.5%;
  }
}
body,
input,
textarea,
button {
  border: none;
  font-family: "Inter", sans-serif;
  font: 400 1rem sans-serif;
}

button {
  color: var(--black-100);
}

body,
input,
textarea {
  color: var(--white);
}

select,
input {
  font-family: Inter, sans-serif;
  font-weight: 400;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 500;
  font-family: "DM Sans", sans-serif;
}

h1 {
  font-size: 3rem;
}

h2 {
  font-size: 1.5rem;
}

p,
a {
  font-family: "inter", sans-serif;
  font-size: 1rem;
}

button {
  cursor: pointer;
}

label {
  font-family: "DM Sans", sans-serif;
  font-size: 0.875rem;
  line-height: 0.875rem;
  color: var(--gray-100);
}

#es02IFulWmU3_ts {
  animation: es02IFulWmU3_ts__ts 2300ms linear infinite normal forwards;
}

@keyframes es02IFulWmU3_ts__ts {
  0% {
    transform: translate(300px, 300px) scale(1, 1);
  }
  43.478261% {
    transform: translate(300px, 300px) scale(2.9, 2.9);
  }
  100% {
    transform: translate(300px, 300px) scale(2.9, 2.9);
  }
}
#es02IFulWmU3 {
  animation: es02IFulWmU3_c_o 2300ms linear infinite normal forwards;
}

@keyframes es02IFulWmU3_c_o {
  0% {
    opacity: 1;
  }
  8.695652% {
    opacity: 1;
  }
  47.826087% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#es02IFulWmU4_ts {
  animation: es02IFulWmU4_ts__ts 2300ms linear infinite normal forwards;
}

@keyframes es02IFulWmU4_ts__ts {
  0% {
    transform: translate(300px, 300px) scale(1, 1);
  }
  39.130435% {
    transform: translate(300px, 300px) scale(2.9, 2.9);
  }
  100% {
    transform: translate(300px, 300px) scale(2.9, 2.9);
  }
}
#es02IFulWmU4 {
  animation: es02IFulWmU4_c_o 2300ms linear infinite normal forwards;
}

@keyframes es02IFulWmU4_c_o {
  0% {
    opacity: 1;
  }
  8.695652% {
    opacity: 1;
  }
  47.826087% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
.swal2-container {
  width: 100vw !important;
  -webkit-backdrop-filter: blur(2px) !important;
          backdrop-filter: blur(2px) !important;
  z-index: 10000 !important;
}

.swal2-title {
  font-family: DM Sans, sans-serif !important;
  font-weight: 500 !important;
  color: #FFF !important;
}

.swal2-popup {
  background-color: var(--black-200) !important;
  color: var(--white) !important;
}

.swal2-html-container {
  margin: 1em 0 !important;
  font-family: Inter, sans-serif !important;
  color: var(--grey-100) !important;
  padding: 0rem 2.5rem !important;
  padding-bottom: 1.5rem !important;
}

.swal2-actions {
  width: 70% !important;
  margin: 0 auto !important;
  flex-direction: row !important;
  margin-bottom: 1.2rem !important;
}

.swal-confirm-btn {
  background-color: var(--primary) !important;
  box-shadow: unset !important;
  box-shadow: 0x 4px 10px rgba(128, 128, 128, 0.25) !important;
  font-family: DM Sans, sans-serif !important;
  color: var(--black-100) !important;
  font-weight: 600 !important;
}

.swal-deny-btn {
  font-family: DM Sans, sans-serif !important;
}

.icon-center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.chartTooltip {
  display: flex;
  flex-direction: column;
  background: var(--black-100);
  border-style: none !important;
  font-family: Inter;
  min-width: 130px;
}
.chartTooltip header > span,
.chartTooltip div > span {
  font-family: Inter;
}
.chartTooltip header {
  border-bottom: 1px solid var(--black-200);
  padding: 0.5rem 0.8rem;
}
.chartTooltip header span {
  font-weight: bold;
}
.chartTooltip > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem 0.8rem;
}
.chartTooltip > div span:first-of-type {
  color: var(--grey-100);
}

.apexcharts-legend {
  display: flex;
  flex-direction: row;
  position: absolute !important;
  top: 5px !important;
}

.apexcharts-legend-series {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
}

.apexcharts-legend-marker {
  margin-right: 0.4rem !important;
}

.apexcharts-tooltip {
  box-shadow: 2px 2px 6px -4px var(--grey-200) !important;
}

.apexcharts-tooltip.apexcharts-theme-light {
  border: none !important;
  background: transparent !important;
}

.swal2-toast-title {
  font-family: DM Sans !important;
  font-weight: 500 !important;
  margin: 0 !important;
  margin-top: 2px !important;
}

.swal2-toast-progress {
  background: var(--primary) !important;
}

.swal2-toast-container {
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
}

.swal2-toast-popup {
  width: auto !important;
  max-width: 30vw !important;
  align-items: center !important;
}

.leaflet-container {
  width: 100vw;
}

.leaflet-control-attribution {
  display: none;
}

.leaflet-div-icon {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leaflet-marker-icon {
  background: transparent;
}
.leaflet-marker-icon .teste {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.leaflet-marker-icon .teste svg {
  width: 100%;
  height: 100%;
}

.carousel .thumbs-wrapper .thumb {
  height: 80px;
  border-radius: 4px;
  border-color: var(--black-300);
  padding: 0;
}
.carousel .thumbs-wrapper .thumb:last-child {
  margin-right: 0;
}
.carousel .thumbs-wrapper .thumb.selected {
  border-color: var(--primary);
}

.pac-item {
  flex-direction: row !important;
  font-family: Inter, sans-serif !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Global.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,oBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAFF;;AAKA;EACE,4BAAA;AAFF;;AAKA;EACE;IACE,iBAAA;EAFF;AACF;AAKA;EACE;IACE,gBAAA;EAHF;AACF;AAMA;;;;EAIE,YAAA;EACA,gCAAA;EACA,yBAAA;AAJF;;AAOA;EACE,uBAAA;AAJF;;AAOA;;;EAGE,mBAAA;AAJF;;AAOA;;EAEE,8BAAA;EACA,gBAAA;AAJF;;AAOA;;;;;;EAME,gBAAA;EACA,kCAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;;EAEE,gCAAA;EACA,eAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,kCAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,qEAAA;AAJF;;AAOA;EACE;IACE,8CAAA;EAJF;EAOA;IACE,kDAAA;EALF;EAQA;IACE,kDAAA;EANF;AACF;AASA;EACE,kEAAA;AAPF;;AAUA;EACE;IACE,UAAA;EAPF;EAUA;IACE,UAAA;EARF;EAWA;IACE,UAAA;EATF;EAYA;IACE,UAAA;EAVF;AACF;AAaA;EACE,qEAAA;AAXF;;AAcA;EACE;IACE,8CAAA;EAXF;EAcA;IACE,kDAAA;EAZF;EAeA;IACE,kDAAA;EAbF;AACF;AAgBA;EACE,kEAAA;AAdF;;AAiBA;EACE;IACE,UAAA;EAdF;EAiBA;IACE,UAAA;EAfF;EAkBA;IACE,UAAA;EAhBF;EAmBA;IACE,UAAA;EAjBF;AACF;AAqBA;EACE,uBAAA;EACA,6CAAA;UAAA,qCAAA;EACA,yBAAA;AAnBF;;AAsBA;EACE,2CAAA;EACA,2BAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,6CAAA;EACA,8BAAA;AAnBF;;AAsBA;EACE,wBAAA;EACA,yCAAA;EACA,iCAAA;EACA,+BAAA;EACA,iCAAA;AAnBF;;AAwBA;EACE,qBAAA;EACA,yBAAA;EAEA,8BAAA;EAEA,gCAAA;AAvBF;;AA2BA;EACE,2CAAA;EACA,4BAAA;EACA,4DAAA;EACA,2CAAA;EACA,kCAAA;EACA,2BAAA;AAxBF;;AA2BA;EACE,2CAAA;AAxBF;;AA2BA;EACE,wBAAA;EACA,8BAAA;EACA,kCAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,sBAAA;EAEA,4BAAA;EAEA,6BAAA;EAEA,kBAAA;EAEA,gBAAA;AA5BF;AA8BE;;EAEE,kBAAA;AA5BJ;AA+BE;EACE,yCAAA;EAEA,sBAAA;AA9BJ;AAgCI;EACE,iBAAA;AA9BN;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,sBAAA;AAjCJ;AAmCI;EACE,sBAAA;AAjCN;;AAsCA;EACE,aAAA;EACA,mBAAA;EAEA,6BAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,wBAAA;EACA,8BAAA;EACA,8BAAA;AApCF;;AAuCA;EACE,+BAAA;AApCF;;AAuCA;EACE,uDAAA;AApCF;;AAuCA;EACE,uBAAA;EACA,kCAAA;AApCF;;AAuCA;EACE,+BAAA;EACA,2BAAA;EACA,oBAAA;EACA,0BAAA;AApCF;;AAuCA;EACE,qCAAA;AApCF;;AAuCA;EACE,wCAAA;UAAA,gCAAA;AApCF;;AAuCA;EACE,sBAAA;EACA,0BAAA;EACA,8BAAA;AApCF;;AAuCA;EACE,YAAA;AApCF;;AAuCA;EACE,aAAA;AApCF;;AAuCA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCF;;AAuCA;EACE,uBAAA;AApCF;AAsCE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AApCJ;AAsCI;EACE,WAAA;EACA,YAAA;AApCN;;AAyCA;EACE,YAAA;EAEA,kBAAA;EAEA,8BAAA;EAEA,UAAA;AAzCF;AA2CE;EACE,eAAA;AAzCJ;AA4CE;EACE,4BAAA;AA1CJ;;AA8CA;EACE,8BAAA;EACA,yCAAA;AA3CF","sourcesContent":["// @import url(\"https://fonts.googleapis.com/css2?family=DM+Sans&display=swap\");\n// @import url(\"https://fonts.googleapis.com/css2?family=Inter&display=swap\");\n// @import url(\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;700&display=swap\");\n:root {\n  --primary: #fccc34;\n  --darker-primary: var(--darker-primary);\n  --green: #47d444;\n  --dark-green: #305f2f;\n  --red: #cc3939;\n  --black-100: #191919;\n  --card-header: #2e2d2d;\n  --black-200: #242424;\n  --black-300: #292828;\n  --black-400: #2e2d2d;\n  --white: #ebebeb;\n  --grey-100: #b8b8b8;\n  --grey-200: #525252;\n  --grey-300: #3d3d3d;\n  --orange: #FF7900;\n  --white-5: #FDFDFD;\n  --white-100: #FFF;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  background: var(--black-100);\n}\n\n@media (max-width: 1080px) {\n  html {\n    font-size: 93.75%;\n  }\n}\n\n@media (max-width: 720px) {\n  html {\n    font-size: 87.5%;\n  }\n}\n\nbody,\ninput,\ntextarea,\nbutton {\n  border: none;\n  font-family: \"Inter\", sans-serif;\n  font: 400 1rem sans-serif;\n}\n\nbutton {\n  color: var(--black-100);\n}\n\nbody,\ninput,\ntextarea {\n  color: var(--white);\n}\n\nselect,\ninput {\n  font-family: Inter, sans-serif;\n  font-weight: 400;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 500;\n  font-family: \"DM Sans\", sans-serif;\n}\n\nh1 {\n  font-size: 3rem;\n}\n\nh2 {\n  font-size: 1.5rem;\n}\n\np,\na {\n  font-family: \"inter\", sans-serif;\n  font-size: 1rem;\n}\n\nbutton {\n  cursor: pointer;\n}\n\nlabel {\n  font-family: \"DM Sans\", sans-serif;\n  font-size: 0.875rem;\n  line-height: 0.875rem;\n  color: var(--gray-100);\n}\n\n#es02IFulWmU3_ts {\n  animation: es02IFulWmU3_ts__ts 2300ms linear infinite normal forwards;\n}\n\n@keyframes es02IFulWmU3_ts__ts {\n  0% {\n    transform: translate(300px, 300px) scale(1, 1);\n  }\n\n  43.478261% {\n    transform: translate(300px, 300px) scale(2.9, 2.9);\n  }\n\n  100% {\n    transform: translate(300px, 300px) scale(2.9, 2.9);\n  }\n}\n\n#es02IFulWmU3 {\n  animation: es02IFulWmU3_c_o 2300ms linear infinite normal forwards;\n}\n\n@keyframes es02IFulWmU3_c_o {\n  0% {\n    opacity: 1;\n  }\n\n  8.695652% {\n    opacity: 1;\n  }\n\n  47.826087% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n#es02IFulWmU4_ts {\n  animation: es02IFulWmU4_ts__ts 2300ms linear infinite normal forwards;\n}\n\n@keyframes es02IFulWmU4_ts__ts {\n  0% {\n    transform: translate(300px, 300px) scale(1, 1);\n  }\n\n  39.130435% {\n    transform: translate(300px, 300px) scale(2.9, 2.9);\n  }\n\n  100% {\n    transform: translate(300px, 300px) scale(2.9, 2.9);\n  }\n}\n\n#es02IFulWmU4 {\n  animation: es02IFulWmU4_c_o 2300ms linear infinite normal forwards;\n}\n\n@keyframes es02IFulWmU4_c_o {\n  0% {\n    opacity: 1;\n  }\n\n  8.695652% {\n    opacity: 1;\n  }\n\n  47.826087% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n//ajustes sweetalert2\n.swal2-container {\n  width: 100vw !important;\n  backdrop-filter: blur(2px) !important;\n  z-index: 10000 !important;\n}\n\n.swal2-title {\n  font-family: DM Sans, sans-serif !important;\n  font-weight: 500 !important;\n  color: #FFF !important;\n}\n\n.swal2-popup {\n  background-color: var(--black-200) !important;\n  color: var(--white) !important;\n}\n\n.swal2-html-container {\n  margin: 1em 0 !important;\n  font-family: Inter, sans-serif !important;\n  color: var(--grey-100) !important;\n  padding: 0rem 2.5rem !important;\n  padding-bottom: 1.5rem !important;\n\n  // width: 100% !important;\n}\n\n.swal2-actions {\n  width: 70% !important;\n  margin: 0 auto !important;\n\n  flex-direction: row !important;\n\n  margin-bottom: 1.2rem !important;\n}\n\n//custom class sweetalert2\n.swal-confirm-btn {\n  background-color: var(--primary) !important;\n  box-shadow: unset !important;\n  box-shadow: 0x 4px 10px rgba(128, 128, 128, 0.25) !important;\n  font-family: DM Sans, sans-serif !important;\n  color: var(--black-100) !important;\n  font-weight: 600 !important;\n}\n\n.swal-deny-btn {\n  font-family: DM Sans, sans-serif !important;\n}\n\n.icon-center {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.chartTooltip {\n  display: flex;\n  flex-direction: column;\n\n  background: var(--black-100);\n\n  border-style: none !important;\n\n  font-family: Inter;\n\n  min-width: 130px;\n\n  header>span,\n  div>span {\n    font-family: Inter;\n  }\n\n  header {\n    border-bottom: 1px solid var(--black-200);\n\n    padding: 0.5rem 0.8rem;\n\n    span {\n      font-weight: bold;\n    }\n  }\n\n  >div {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    padding: 0.5rem 0.8rem;\n\n    span:first-of-type {\n      color: var(--grey-100);\n    }\n  }\n}\n\n.apexcharts-legend {\n  display: flex;\n  flex-direction: row;\n\n  position: absolute !important;\n  top: 5px !important;\n}\n\n.apexcharts-legend-series {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n}\n\n.apexcharts-legend-marker {\n  margin-right: 0.4rem !important;\n}\n\n.apexcharts-tooltip {\n  box-shadow: 2px 2px 6px -4px var(--grey-200) !important;\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: none !important;\n  background: transparent !important;\n}\n\n.swal2-toast-title {\n  font-family: DM Sans !important;\n  font-weight: 500 !important;\n  margin: 0 !important;\n  margin-top: 2px !important;\n}\n\n.swal2-toast-progress {\n  background: var(--primary) !important;\n}\n\n.swal2-toast-container {\n  backdrop-filter: none !important;\n}\n\n.swal2-toast-popup {\n  width: auto !important;\n  max-width: 30vw !important;\n  align-items: center !important;\n}\n\n.leaflet-container {\n  width: 100vw;\n}\n\n.leaflet-control-attribution {\n  display: none;\n}\n\n.leaflet-div-icon {\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.leaflet-marker-icon {\n  background: transparent;\n\n  .teste {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n\n.carousel .thumbs-wrapper .thumb {\n  height: 80px;\n\n  border-radius: 4px;\n\n  border-color: var(--black-300);\n\n  padding: 0;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  &.selected {\n    border-color: var(--primary);\n  }\n}\n\n.pac-item {\n  flex-direction: row !important;\n  font-family: Inter, sans-serif !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
